var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"text-center py-1 font-size-14",class:{ 'font-size-12': _vm.$vuetify.breakpoint.xsOnly }},[_c('div',{staticClass:"text--secondary"},[_vm._v(" © "+_vm._s(_vm.$utils.dayjs().format("YYYY"))+" Payfoot | "),_c('router-link',{staticClass:"btn-basic",attrs:{"to":{ name: 'privacyPolicy' }}},[_vm._v(" Privacy policy ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }